<template>
    <div class="row">
        <div class="col-md-12">
            <div class="mb-3">
                <label for="kt_platform" class="col-form-label">Platform</label>
                <select class="form-select" id="kt_platform" v-model="form.kt_platform" @change="changePlatform()">
                    <option  v-for="(serverPlatform, index) in serverPlatforms" :key="'kt_platform_'+index" :value="serverPlatform.label">
                        {{ serverPlatform.value }}
                    </option>
                </select>
                <v-errors :errors="errorFor('kt_platform')"></v-errors>
            </div>
            <div class="mb-3">
                <label for="cloud_network_id" class="col-form-label">Network</label>
                <select class="form-select" id="cloud_network_id" v-model="form.cloud_network_id" @change="changeNetwork()">
                    <option  v-for="(cloudNetwork, index) in cloudNetworks" :key="'cloud_network_'+index" :value="cloudNetwork.id">
                        {{ cloudNetwork.public_ip }}
                    </option>
                </select>
                <v-errors :errors="errorFor('cloud_network_id')"></v-errors>
            </div>
            <template v-if="form.kt_platform == 'g'">
                <div class="mb-3">
                    <label for="ip_range" class="col-form-label">Access source (Default: 0.0.0.0/0)</label>
                    <input type="text" class="form-control" id="ip_range" v-model="form.ip_range">
                    <v-errors :errors="errorFor('ip_range')"></v-errors>
                </div>
                <div class="row">
                    <div class="col_6">
                        <div class="mb-3">
                            <label for="starting_port" class="col-form-label">Starting port</label>
                            <input type="text" class="form-control" id="starting_port" v-model="form.starting_port">
                            <v-errors :errors="errorFor('starting_port')"></v-errors>
                        </div>
                    </div>
                    <div class="col_6">
                        <div class="mb-3">
                            <label for="end_port" class="col-form-label">End port</label>
                            <input type="text" class="form-control" id="end_port" v-model="form.end_port">
                            <v-errors :errors="errorFor('end_port')"></v-errors>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row">
                    <div class="col_6">
                        <div class="mb-3">
                            <label for="kt_tier_id" class="col-form-label">Destination network</label>
                            <select class="form-select" id="kt_tier_id" v-model="form.kt_tier_id" @change="changeTier()">
                                <option  v-for="(ktTier, index) in ktTiers" :key="'kt_tier_'+index" :value="ktTier.id">
                                    {{ ktTier.name }}
                                </option>
                            </select>
                            <v-errors :errors="errorFor('kt_tier_id')"></v-errors>
                        </div>
                    </div>
                    <div class="col_6">
                        <div class="mb-3">
                            <label for="port_forwarding_id" class="col-form-label">Port forwarding</label>
                            <select class="form-select" id="port_forwarding_id" v-model="form.port_forwarding_id">
                                <option  v-for="(portForwarding, index) in portForwardings" :key="'port_forwarding_id_'+index" :value="portForwarding.id">
                                    PF_{{ portForwarding?.cloudNetwork.public_ip }}_{{ portForwarding.public_port_one }}_{{ portForwarding.protocol }}
                                </option>
                            </select>
                            <v-errors :errors="errorFor('port_forwarding_id')"></v-errors>
                        </div>
                    </div>
                </div>
            </template>
            <div class="mb-3">
                <label for="protocol" class="col-form-label">Network</label>
                <select class="form-select" id="protocol" v-model="form.protocol">
                    <option value="tcp">TCP</option>
                    <option value="udp">UDP</option>
                    <option value="icmp">ICMP</option>
                </select>
                <v-errors :errors="errorFor('protocol')"></v-errors>
            </div>
            <div class="mb-3">
                <div class="d_flex_start">
                    <button type="button" class="btn btn-primary btn-md  width_100p mr_10" :disabled="lyLoading" @click.prevent="submit" v-if="form.kt_platform == 'g'">Submit</button>
                    <button type="button" class="btn btn-primary btn-md  width_100p mr_10" :disabled="lyLoading" @click.prevent="submitForDPlatform" v-else>Submit</button>
                    <button type="button" class="btn btn-danger btn-md  width_100p" @click.prevent="closeModal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
      export default {
          name: 'firewall-form',
          props: ['closeModal','loadData'],
          data(){
              return {
                lyLoading: false,
                form: {
                    kt_platform: 'g',
                    cloud_network_id: '',
                    kt_tier_id: '',
                    port_forwarding_id: '',
                    protocol: 'tcp',
                    ip_range: '',
                    starting_port: '',
                    end_port: '',
                },
                cloudNetworks: [],
                ktTiers: [],
                portForwardings: [],
                serverPlatforms: [
                    {label: 'g', value: 'G'},
                    {label: 'd', value: 'D'},
                ],
              }
          },
          created() {
              this.loadCloudNetworks()
              this.loadKtTiers()
          },
          methods: {
            changePlatform(){
                this.loadCloudNetworks()
            },
            loadCloudNetworks() {
                this.axios.get('/platform-cloud-networks/'+this.form.kt_platform)
                .then(({data}) => {
                    this.cloudNetworks = data.data
                    if(this.cloudNetworks.length > 0){
                        this.form.cloud_network_id = this.cloudNetworks[0].id
                        if(this.form.kt_platform == 'd'){
                            this.fetchPortForwardings()
                        }
                    }else{
                        this.cloudNetworks = []
                        this.form.cloud_network_id = null
                    }
                })
            },
            loadKtTiers() {
                this.axios.get('/get-kt-tiers')
                .then(({data}) => {
                    this.ktTiers = data.data
                    if(this.ktTiers.length > 0){
                        this.form.kt_tier_id = this.ktTiers[0].id
                        if(this.form.kt_platform == 'd'){
                            this.fetchPortForwardings()
                        }
                    }else{
                        this.ktTiers = []
                        this.form.kt_tier_id = null
                    }
                })
            },
            changeNetwork(){
                this.fetchPortForwardings()
            },
            changeTier(){
                this.fetchPortForwardings()
            },
            fetchPortForwardings() {
                this.axios.get('/fetch-port-forwardings/'+this.form.kt_tier_id+'/'+this.form.cloud_network_id)
                .then(({data}) => {
                    this.portForwardings = data.data
                    if(this.portForwardings.length > 0){
                        this.form.port_forwarding_id = this.portForwardings[0].id
                    }else{
                        this.portForwardings = []
                        this.form.port_forwarding_id = null
                    }
                })
            },
            submit() {
                this.allErrors = null;
                this.lyLoading = true;
                
                this.axios.post('/firewalls', this.form)
                .then((response) => {
                    if(response.data.success){
                        this.showSuccessMsg(response.data.message);
                        this.closeModal()
                        this.loadData()
                    }else{
                        this.$swal({
                            text: response.data.message,
                            showCancelButton: false,
                            confirmButtonText: 'Close!',
                            confirmButtonColor: '#dd4b39',
                            reverseButtons: true
                        })
                    }
                })
                .catch((err) => {
                    this.allErrors = err.response.data.errors
                    this.showFailMsg(err.response.data.message);
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
            submitForDPlatform() {
                this.allErrors = null;
                this.lyLoading = true;
                
                this.axios.post('/create-kt-d-firewall', this.form)
                .then((response) => {
                    if(response.data.success){
                        this.showSuccessMsg(response.data.message);
                        this.closeModal()
                        this.loadData()
                    }else{
                        this.$swal({
                            text: response.data.message,
                            showCancelButton: false,
                            confirmButtonText: 'Close!',
                            confirmButtonColor: '#dd4b39',
                            reverseButtons: true
                        })
                    }
                })
                .catch((err) => {
                    this.allErrors = err.response.data.errors
                    this.showFailMsg(err.response.data.message);
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
          }
      }
  </script>
  <style scoped>

  </style>
  